import { PureRequestInterceptor } from '../types';
import { store } from '../../app/store';
import { selectServiceURL } from '../../app/slices/auth.slice';

export const origin: PureRequestInterceptor = (config) => {
	const origin = getApiURL();
	config.baseURL = `${origin}`;
	return config;
};

const getApiURL = (): string => {
	const state = store.getState();
	const apiURL = selectServiceURL(state);
	if (!apiURL) throw new Error(`Api URL not defined inside store, received: ${apiURL}`);
	return apiURL;
};
